import {
  IconButton,
  Stack,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { copyKizText, getShortKiz } from "../../utils/kiz";

const PREFIX_RE = /^01\d{14}21/;
const CRYPTO_TAIL_LEN = 44;
const GS = String.fromCharCode(29);

function normalizeKizWithGs(raw = "") {
  const code = String(raw || "").trim();
  if (!code) return "";

  const normalizedMarkers = code.replace(/<\s*(?:GS|XH|0x1D)\s*>/gi, GS);
  const collapsed = normalizedMarkers.split(GS).join("");
  const prefixMatch = collapsed.match(PREFIX_RE);
  if (!prefixMatch) {
    return normalizedMarkers;
  }

  const prefixLen = prefixMatch[0].length;
  const idx91 = collapsed.length - (2 + 4 + 2 + CRYPTO_TAIL_LEN);
  const idx92 = idx91 + 6;

  if (
    idx91 <= prefixLen ||
    collapsed.slice(idx91, idx91 + 2) !== "91" ||
    collapsed.slice(idx92, idx92 + 2) !== "92"
  ) {
    return normalizedMarkers;
  }

  const prefix = collapsed.slice(0, prefixLen);
  const serial = collapsed.slice(prefixLen, idx91);
  const keyId = collapsed.slice(idx91 + 2, idx91 + 6);
  const crypto = collapsed.slice(idx92 + 2);

  return `${prefix}${serial}${GS}91${keyId}${GS}92${crypto}`;
}

function formatGsForView(raw = "") {
  return String(raw || "").split(GS).join("<GS>");
}

export default function KizCopyFields({ it, showShort = true }) {
  const fullKiz = String(it.kiz_code || "");
  const shortKiz = getShortKiz(fullKiz);
  const fullKizWithGs = normalizeKizWithGs(fullKiz);
  const visibleKizWithGs = formatGsForView(fullKizWithGs);

  return (
    <>
      <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5 }}>
        КИЗ (полный):
      </Typography>
      <Stack direction="row" spacing={1} sx={{ mt: 0.5 }}>
        <TextField
          size="small"
          fullWidth
          value={fullKiz}
          placeholder="КИЗ отсутствует"
        />
        <Tooltip title={fullKiz ? "Скопировать полный КИЗ" : "Нет КИЗ"}>
          <span>
            <IconButton
              size="small"
              aria-label="Скопировать полный КИЗ"
              disabled={!fullKiz}
              onClick={() => copyKizText(fullKiz)}
            >
              <ContentCopyIcon fontSize="inherit" />
            </IconButton>
          </span>
        </Tooltip>
      </Stack>

      <Typography variant="caption" color="text.secondary" sx={{ mt: 1 }}>
        КИЗ для ozon доп. информации:
      </Typography>
      <Stack direction="row" spacing={1} sx={{ mt: 0.5 }}>
        <TextField
          size="small"
          fullWidth
          value={visibleKizWithGs}
          placeholder="—"
        />
        <Tooltip title={fullKizWithGs ? "Скопировать КИЗ с GS" : "Нет КИЗ"}>
          <span>
            <IconButton
              size="small"
              aria-label="Скопировать КИЗ с GS"
              disabled={!fullKizWithGs}
              onClick={() => copyKizText(fullKizWithGs)}
            >
              <ContentCopyIcon fontSize="inherit" />
            </IconButton>
          </span>
        </Tooltip>
      </Stack>

      {showShort && (
        <>
          <Typography variant="caption" color="text.secondary" sx={{ mt: 1 }}>
            Короткий КИЗ:
          </Typography>
          <Stack direction="row" spacing={1} sx={{ mt: 0.5 }}>
            <TextField size="small" fullWidth value={shortKiz} placeholder="—" />
            <Tooltip title={shortKiz ? "Скопировать короткий КИЗ" : "Нет КИЗ"}>
              <span>
                <IconButton
                  size="small"
                  aria-label="Скопировать короткий КИЗ"
                  disabled={!shortKiz}
                  onClick={() => copyKizText(shortKiz)}
                >
                  <ContentCopyIcon fontSize="inherit" />
                </IconButton>
              </span>
            </Tooltip>
          </Stack>
        </>
      )}
    </>
  );
}
